var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header bg-gradient-secondary py-7 py-lg-8 pt-lg-9"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header-body mb-7"},[_c('div',{staticClass:"row justify-content-center"},[_c('router-view')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }